import SetCurrentComponent from "@/core/services/SetCurrentComponent";

const cadastro_do_responsavel_do_aluno = {
  path: "/cadastro-responsavel-aluno",
  redirect: "/cadastro-responsavel-aluno",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Manutenção de Aluno",
  },
  children: [
    {
      path: "/cadastro-responsavel-aluno",
      name: "cadastro_responsavel_aluno",
      meta: {
        allowedPermissions: ["responsavel_index"],
      },
      component: SetCurrentComponent(
        "CadastroDoResponsavelDoAluno",
        "CadastroDoResponsavelDoAlunoHome"
      ),
    },
    {
      path: "/cadastro-responsavel-aluno/novo",
      name: "cadastro_responsavel_aluno_cad",
      meta: {
        allowedPermissions: ["responsavel_create"],
      },
      component: SetCurrentComponent(
        "CadastroDoResponsavelDoAluno",
        "CadastroDoResponsavelDoAlunoCad"
      ),
    },
    {
      path: "/cadastro-responsavel-aluno/edit/:id",
      name: "cadastro_responsavel_aluno_atualizar",
      meta: {
        allowedPermissions: ["responsavel_edit"],
      },
      component: SetCurrentComponent(
        "CadastroDoResponsavelDoAluno",
        "CadastroDoResponsavelDoAlunoEdit"
      ),
    },
    {
      path: "/cadastro-de-aluno/dados-de-deficiencia-do-aluno/:id",
      name: "dados_de_defeciencia_do_aluno",
      meta: {
        allowedPermissions: ["atualizar_deficiencia_aluno"],
      },
      component: SetCurrentComponent(
        "CadastroDeAluno/Pages/DeficienciasAluno",
        "DeficienciasAluno"
      ),
    },
  ],
};

export { cadastro_do_responsavel_do_aluno };
